function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.0146027 37.769C0.375137 48.3447 23.7784 77.2028 58.1464 77.2028C90.2521 77.2028 114.467 59.4909 116.278 37.769C119.663 -2.86139 74.2759 -7.81835 52.7249 13.1031C40.3405 25.125 30.4393 33.2638 17.5231 31.877C12.2187 31.3064 5.89136 28.5367 2.25896 31.3975C-0.138596 33.2836 -0.0259552 36.5724 0.0146027 37.769Z",
  fill: "#EDF8FF"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1511_3033)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M75.6187 21.3046C79.6669 14.9566 88.0945 13.0918 94.4429 17.1395C100.791 21.1877 102.657 29.6162 98.6089 35.9647L95.2358 33.8143C98.0959 29.3286 96.778 23.3731 92.2925 20.5126C87.8067 17.6526 81.8512 18.9695 78.9907 23.455C76.3986 27.5202 77.2377 32.793 80.7563 35.8749C80.7579 35.8721 80.7606 35.8698 80.7622 35.8671L84.2388 37.8436C81.4066 42.8243 80.5706 44.2809 79.7349 45.7372C79.3551 46.3988 78.9749 47.0605 78.4058 48.0565C79.3952 49.1263 80.0005 50.5567 80.0005 52.1288C80.0004 55.4424 77.3142 58.1288 74.0005 58.1288C70.6868 58.1288 68.0006 55.4424 68.0005 52.1288C68.0005 48.8151 70.6868 46.1288 74.0005 46.1288C74.2943 46.1288 74.5832 46.1505 74.8657 46.1913C75.474 45.1266 75.8702 44.4368 76.2661 43.747C76.8567 42.7179 77.4455 41.687 78.7485 39.4003C73.2432 35.1328 71.7999 27.2935 75.6187 21.3046Z",
  fill: "#CB73F8"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M74.0244 66.3048C66.5027 65.9731 60.674 59.6069 61.0053 52.0851C61.3369 44.5632 67.7027 38.734 75.2245 39.0651L75.0488 43.0615C69.7338 42.8275 65.235 46.9464 65.0008 52.2614C64.7668 57.5761 68.8855 62.074 74.2002 62.3085C79.0169 62.5208 83.1642 59.1586 84.0738 54.5703C84.0707 54.5703 84.0672 54.5691 84.0641 54.5691L84.0376 50.5701C89.7669 50.5325 91.4466 50.5281 93.1256 50.5238C93.8886 50.5218 94.6519 50.5198 95.7996 50.5147C96.2314 49.1232 97.167 47.8839 98.5281 47.098C101.398 45.4411 105.067 46.4245 106.724 49.2941C108.381 52.1639 107.398 55.8334 104.528 57.4903C101.658 59.1468 97.9887 58.1637 96.3319 55.2941C96.185 55.0396 96.0593 54.7786 95.9534 54.5135C94.7273 54.5191 93.9318 54.5209 93.1364 54.5229C91.9498 54.526 90.7627 54.5307 88.1303 54.5456C87.1876 61.4474 81.1206 66.6174 74.0244 66.3048Z",
  fill: "#8099F5"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M113.457 46.1397C116.93 52.8196 114.331 61.0513 107.651 64.5253C100.971 67.9987 92.7398 65.4004 89.2657 58.7211L92.8145 56.8751C95.2694 61.5949 101.086 63.4307 105.806 60.9761C110.526 58.5212 112.362 52.7055 109.908 47.9856C107.683 43.7081 102.697 41.7982 98.2689 43.3047C98.2705 43.3075 98.2712 43.311 98.2728 43.3137L94.8227 45.3362C91.9254 40.3932 91.0819 38.9409 90.2387 37.489C89.8555 36.8293 89.4727 36.1692 88.8946 35.1782C87.4734 35.5003 85.9321 35.3092 84.5706 34.5232C81.7008 32.8663 80.7176 29.1968 82.3744 26.327C84.0313 23.4575 87.7009 22.4741 90.5706 24.1309C93.4399 25.7878 94.4233 29.4575 92.7667 32.327C92.6199 32.5814 92.4565 32.8209 92.28 33.0451C92.8979 34.1042 93.2971 34.7922 93.6966 35.48C94.2925 36.506 94.8903 37.5313 96.2189 39.8027C102.667 37.1681 110.179 39.838 113.457 46.1397Z",
  fill: "#8099F5"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_1511_3033)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 46.0005,
  y: 24,
  width: 28.3693,
  height: 37.6944,
  rx: 6,
  fill: "#CEF2FF",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.3752 33.5586L66.6936 33.5586C68.5492 33.5586 70.0684 32.1121 70.0684 30.3452C70.0684 28.5783 68.5492 27.1318 66.6936 27.1318L52.3752 27.1318C50.5196 27.1318 49.0005 28.5783 49.0005 30.3452C49.0005 32.1121 50.5196 33.5586 52.3752 33.5586Z",
  fill: "#E0B0F8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.8708 26.0016C64.3869 26.0016 62.3733 27.9189 62.3733 30.284C62.3733 32.6491 64.3869 34.5664 66.8707 34.5664C69.3546 34.5664 71.3682 32.6491 71.3682 30.284C71.3682 27.9189 69.3546 26.0016 66.8708 26.0016Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.9935 39.5742H53.675C51.8194 39.5742 50.3003 41.0207 50.3003 42.7876C50.3003 44.5545 51.8194 46.001 53.675 46.001H67.9935C69.8491 46.001 71.3682 44.5545 71.3682 42.7876C71.3682 41.0207 69.8491 39.5742 67.9935 39.5742Z",
  fill: "#E0B0F8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.4979 47.1312C55.9818 47.1312 57.9953 45.2139 57.9953 42.8488C57.9953 40.4837 55.9818 38.5664 53.4979 38.5664C51.014 38.5664 49.0005 40.4837 49.0005 42.8488C49.0005 45.2139 51.014 47.1312 53.4979 47.1312Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.3752 58.6807H66.6936C68.5492 58.6807 70.0684 57.2342 70.0684 55.4673C70.0684 53.7004 68.5492 52.2539 66.6936 52.2539H52.3752C50.5196 52.2539 49.0005 53.7004 49.0005 55.4673C49.0005 57.2342 50.5196 58.6807 52.3752 58.6807Z",
  fill: "#E0B0F8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.8724 59.6937C69.3563 59.6937 71.3698 57.7764 71.3698 55.4113C71.3698 53.0462 69.3563 51.1289 66.8724 51.1289C64.3886 51.1289 62.375 53.0462 62.375 55.4113C62.375 57.7764 64.3886 59.6937 66.8724 59.6937Z",
  fill: "white"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M107.141 83.1419C113.426 76.8568 113.426 66.6666 107.141 60.3815C100.856 54.0964 90.6658 54.0964 84.3807 60.3815C78.0956 66.6666 78.0956 76.8568 84.3807 83.1419C90.6658 89.4271 100.856 89.4271 107.141 83.1419Z",
  fill: "#CB73F8"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M97.1762 81.9011C96.8134 82.2638 96.3152 82.4872 95.7615 82.4872C94.6561 82.4891 93.7589 81.5918 93.7608 80.4865L93.7608 63.0448C93.7589 61.9394 94.6561 61.0421 95.7615 61.044C96.8669 61.0421 97.7642 61.9394 97.7623 63.0448L97.7623 80.4865C97.7623 81.0401 97.5389 81.5384 97.1762 81.9011Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M105.899 73.1803C105.536 73.543 105.038 73.7664 104.484 73.7664L87.0426 73.7664C85.9373 73.7683 85.04 72.871 85.0419 71.7656C85.04 70.6602 85.9373 69.763 87.0426 69.7649L104.484 69.7649C105.59 69.763 106.487 70.6602 106.485 71.7656C106.485 72.3193 106.262 72.8175 105.899 73.1803Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_1511_3033",
  x: 34.0005,
  y: 14,
  width: 52.3691,
  height: 61.6953,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.156863 0 0 0 0 0.215686 0 0 0 0 0.556863 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1511_3033"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1511_3033",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1511_3033"
}, /*#__PURE__*/React.createElement("rect", {
  width: 69,
  height: 69,
  fill: "white",
  transform: "translate(55.0005)"
})));

function SvgIconEmailConfigure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    "aria-hidden": "true",
    height: 88,
    viewBox: "0 0 124 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmailConfigure);
export default __webpack_public_path__ + "static/media/icon-email-configure.749a24b6be76d0b67fe46e05d589a771.svg";
export { ForwardRef as ReactComponent };